/* @flow */
import * as React from 'react';
import { markAccountCreationStart } from 'utils/accountCompletionTracker';

class JoinView extends React.Component<$FlowFixMeProps> {
  componentDidMount() {
    markAccountCreationStart();
  }

  render() {
    return this.props.children;
  }
}

export default JoinView;
